import React from "react";
import Input from "./Input";
import { AnimatePresence, motion } from "framer-motion";
import { leftContent, rightContent } from "../data/anim";
const Signin = ({ setLogin, errors, handleChange, handleSubmit }) => {
  return (
    <motion.form
      variants={leftContent}
      initial="hidden"
      animate="visible"
      exit="exit"
      onSubmit={handleSubmit}
    >
      <Input
        type="email"
        id="email"
        name="email"
        direction="column"
        errorHandler="true"
        handleChange={handleChange}
        placeholder={errors.email}
      />
      <Input
        type="password"
        id="password"
        name="password"
        direction="column"
        errorHandler="true"
        handleChange={handleChange}
        placeholder={errors.password}
      />
      <button className="authBtn">Login</button>
      <p>
        Need and account? <span onClick={() => setLogin(false)}>Sign up</span>
      </p>
    </motion.form>
  );
};

export default Signin;
